<template>
  <div class="login-container">
    <!-- 背景层 -->
    <div class="background-layer">
      <img src="@/assets/img/img23.png" class="bg-img" />
      <div class="bg-overlay"></div>
    </div>

    <!-- 内容层 -->
    <div class="content-layer">
      <div class="login-content">
        <!-- Logo区域 -->
        <div class="logo-box">
          <div class="logo-circle"></div>
          <div class="logo-text">
            <div class="main-text">小助手</div>
            <div class="sub-text">ASSISTANT</div>
          </div>
        </div>

        <!-- 欢迎标题 -->
        <div class="welcome-title">
          <div class="welcome-text">欢迎登录</div>
          <div class="welcome-subtext">Welcome Back</div>
        </div>

        <!-- 登录表单 -->
        <div class="login-form">
          <div class="form-item" :class="{ 'active': username }">
            <div class="form-label">
              <i class="el-icon-user label-icon"></i>
              <span>账 号</span>
            </div>
            <el-input 
              v-model="username" 
              placeholder="请输入账号"
              @focus="handleInputFocus('username')"
              @blur="handleInputBlur('username')"
            ></el-input>
          </div>

          <div class="form-item" :class="{ 'active': password }">
            <div class="form-label">
              <i class="el-icon-lock label-icon"></i>
              <span>密 码</span>
            </div>
            <el-input 
              v-model="password" 
              type="password"
              placeholder="请输入密码"
              @focus="handleInputFocus('password')"
              @blur="handleInputBlur('password')"
              @keyup.enter="nextBtn"
            ></el-input>
          </div>
        </div>

        <!-- 登录按钮 -->
        <div class="login-btn-box">
          <div 
            class="login-btn" 
            @click="nextBtn"
            :class="{ 'loading': isLoading }"
          >
            <span v-if="!isLoading">登录</span>
            <i v-else class="el-icon-loading"></i>
          </div>
        </div>

        <!-- 底部提示 -->
        <div class="login-footer">
          <div class="footer-line"></div>
          <div class="footer-text">欢迎使用小助手管理系统</div>
        </div>
      </div>
    </div>

    <!-- 消息组件 -->
    <message :title="messageTitile" ref="messageRef"></message>
  </div>
</template>

<script>
import { setToken, removeToken } from "@/utils/auth";
import { login, getInfo } from "@/http/index";
import message from "@/components/message.vue";

export default {
  components: { message },
  data() {
    return {
      messageTitile: "",
      username: "",
      password: "",
      isLoading: false,
      activeInput: null
    };
  },
  created() {
    // 自动填充上次登录的账号（可选）
    const lastUser = localStorage.getItem('lastUsername');
    if (lastUser) {
      this.username = lastUser;
    }
  },
  methods: {
    getInfo() {
      getInfo().then((res) => {
        if (res.code == 200) {
          localStorage.setItem("userInfo", JSON.stringify(res.data.user));
          localStorage.setItem("permissions", JSON.stringify(res.data.permissions));
          localStorage.setItem("firstMenus", JSON.stringify(res.data.firstMenus));
          localStorage.setItem("secondMenus", JSON.stringify(res.data.secondMenus));
          // 保存本次登录的账号
          localStorage.setItem('lastUsername', this.username);
          this.$router.push("/home");
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    
    nextBtn() {
      if (!this.username) {
        this.showMessage("请输入用户名");
        return;
      }
      if (!this.password) {
        this.showMessage("请输入密码");
        return;
      }

      this.isLoading = true;
      
      login({
        username: this.username,
        password: this.password,
      }).then((res) => {
        if (res.code == 200) {
          setToken(res.data.token);
          this.getInfo();
        } else {
          this.showMessage(res.msg || "登录失败");
          this.isLoading = false;
        }
      }).catch((error) => {
        // this.showMessage("网络错误，请重试");
        this.isLoading = false;
      });
    },
    
    showMessage(msg) {
      this.messageTitile = msg;
      this.$refs.messageRef.show();
    },
    
    handleInputFocus(field) {
      this.activeInput = field;
    },
    
    handleInputBlur(field) {
      if (field === this.activeInput) {
        this.activeInput = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
}

/* 背景层 */
.background-layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;

  .bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .bg-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.95) 60%);
  }
}

/* 内容层 */
.content-layer {
  position: relative;
  z-index: 2;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-content {
  width: 100%;
  max-width: 400px;
  animation: fadeInUp 0.8s ease-out;
}

/* Logo区域 */
.logo-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
  animation: slideDown 0.6s ease-out;

  .logo-circle {
    width: 50px;
    height: 50px;
    background: linear-gradient(135deg, #FF813D, #FFB347);
    border-radius: 50%;
    margin-right: 15px;
    box-shadow: 0 8px 20px rgba(255, 129, 61, 0.25);
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 30px;
      height: 30px;
      background: white;
      border-radius: 50%;
    }
  }

  .logo-text {
    text-align: left;
    
    .main-text {
      font-size: 24px;
      font-weight: 700;
      color: #303133;
      letter-spacing: 2px;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    }
    
    .sub-text {
      font-size: 12px;
      color: #FF813D;
      font-weight: 500;
      letter-spacing: 1px;
      opacity: 0.8;
    }
  }
}

/* 欢迎标题 */
.welcome-title {
  margin-bottom: 50px;
  text-align: center;
  animation: slideDown 0.6s ease-out 0.1s both;

  .welcome-text {
    font-size: 32px;
    font-weight: 700;
    color: #303133;
    margin-bottom: 10px;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -5px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 3px;
      background: linear-gradient(90deg, #FF813D, #FFB347);
      border-radius: 2px;
    }
  }

  .welcome-subtext {
    font-size: 14px;
    color: #666;
    opacity: 0.8;
    letter-spacing: 2px;
  }
}

/* 登录表单 - 修改部分 */
.login-form {
  margin-bottom: 40px;
  animation: slideUp 0.6s ease-out 0.2s both;

  .form-item {
    background: white;
    border-radius: 16px;
    padding: 0 20px;
    margin-bottom: 20px;
    box-shadow: 0 6px 20px rgba(102, 25, 17, 0.08);
    border: 2px solid transparent;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    position: relative;
    
    /* 修改为一行显示 */
    display: flex;
    align-items: center;
    height: 60px;
    
    &.active {
      border-color: rgba(255, 129, 61, 0.3);
      box-shadow: 0 8px 25px rgba(255, 129, 61, 0.15);
      
      .form-label {
        .label-icon,
        span {
          color: #FF813D;
        }
      }
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 30px rgba(102, 25, 17, 0.12);
      
      .form-label {
        .label-icon,
        span {
          color: #FF813D;
        }
      }
    }

    .form-label {
      display: flex;
      align-items: center;
      min-width: 70px; /* 固定宽度，保持对齐 */
      font-size: 16px;
      color: #666;
      transition: color 0.3s ease;
      
      .label-icon {
        margin-right: 10px;
        font-size: 18px;
      }
      
      span {
        font-weight: 500;
        white-space: nowrap;
      }
    }

    ::v-deep .el-input {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      
      .el-input__wrapper {
        background: transparent;
        border: none;
        box-shadow: none;
        padding: 0;
        height: 100%;
        display: flex;
        align-items: center;
      }
      
      .el-input__inner {
        border: none;
        padding: 0;
        font-size: 16px;
        color: #303133;
        background: transparent;
        height: auto;
        line-height: normal;
        font-weight: 500;
        width: 100%;

        &::placeholder {
          color: #C0C4CC;
        }

        &:focus {
          outline: none;
          box-shadow: none;
        }
      }
    }
  }
}

/* 登录按钮 */
.login-btn-box {
  animation: slideUp 0.6s ease-out 0.3s both;

  .login-btn {
    background: linear-gradient(135deg, #FF813D, #FFB347);
    border-radius: 16px;
    height: 56px;
    color: white;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    box-shadow: 0 8px 20px rgba(255, 129, 61, 0.3);
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
      transition: left 0.5s ease;
    }

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 12px 25px rgba(255, 129, 61, 0.4);
      
      &::before {
        left: 100%;
      }
    }

    &:active {
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(255, 129, 61, 0.3);
    }

    &.loading {
      opacity: 0.8;
      cursor: not-allowed;
      
      &:hover {
        transform: none;
        box-shadow: 0 8px 20px rgba(255, 129, 61, 0.3);
      }
      
      .el-icon-loading {
        font-size: 22px;
        animation: rotating 2s linear infinite;
      }
    }
  }
}

/* 底部提示 */
.login-footer {
  margin-top: 50px;
  text-align: center;
  animation: fadeIn 0.8s ease-out 0.4s both;

  .footer-line {
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 129, 61, 0.3), transparent);
    margin-bottom: 20px;
  }

  .footer-text {
    font-size: 14px;
    color: #666;
    opacity: 0.6;
  }
}

/* 动画定义 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 响应式调整 */
@media (max-width: 360px) {
  .content-layer {
    padding: 15px;
  }
  
  .login-content {
    padding-top: 40px;
  }
  
  .welcome-title .welcome-text {
    font-size: 28px;
  }
  
  .logo-box {
    margin-bottom: 30px;
  }
  
  .logo-circle {
    width: 45px;
    height: 45px;
  }
  
  .login-form .form-item {
    padding: 0 16px;
    margin-bottom: 16px;
    height: 56px;
    
    .form-label {
      min-width: 60px;
      font-size: 15px;
      
      .label-icon {
        margin-right: 8px;
        font-size: 16px;
      }
    }
  }
  
  .login-btn {
    height: 50px;
    font-size: 16px;
  }
}

@media (min-width: 768px) {
  .login-content {
    max-width: 450px;
    padding: 40px;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(102, 25, 17, 0.1);
  }
}
</style>